import { FC } from "react";
import { Assurance } from "../../lib/interfaces/assurance.interface";
import { TableCell, TableRow } from "../ui/table";
import { formatDate } from "../../lib/helpers/date_helpers";
import { Button } from "../ui/button";
import { Download } from "lucide-react";
import saveAs from "file-saver";
import { toast } from "sonner";
import { useAttestationAssuranceFile } from "@/lib/hooks/useAssurances";

interface Props {
  assurance: Assurance;
}

const AttestationAssuranceRowItem: FC<Props> = ({ assurance: assu }) => {
  const { mutateAsync: getAttestationFile, isPending: loadingAttestation } = useAttestationAssuranceFile();
  const facturesImpayees = assu.factures.filter((fac) => fac.payee === false);

  /* Ouvre l'attestation dans nouvelle fenetre */
  const telechargerAttestation = async () => {
    try {
      const data = await getAttestationFile(assu.id);
      const blob = new Blob([data], {
        type: "application/pdf",
      });
      saveAs(blob, "attestation-assurance.pdf");
    } catch (error) {
      toast.error("Une erreur s'est produite.");
    }
  };

  return (
    <TableRow className="block px-4 py-3 hover:bg-slate-50/70 sm:table-row sm:px-0 sm:py-0">
      <TableCell className="block px-0 pb-2 pt-0 font-semibold text-slate-900 sm:table-cell sm:px-6 sm:py-4">
        {assu.typeAssurance.description}
      </TableCell>
      <TableCell className="flex items-center justify-between gap-4 px-0 py-1.5 text-sm text-slate-600 sm:table-cell sm:p-4">
        <span className="font-medium text-slate-500 sm:hidden">Validité</span>
        <span>Du {formatDate(assu.dateDebut)} au {formatDate(assu.dateFin)}</span>
      </TableCell>
      <TableCell className="flex items-center justify-between gap-4 px-0 py-1.5 text-sm text-slate-600 sm:table-cell sm:p-4">
        <span className="font-medium text-slate-500 sm:hidden">Ruches couvertes</span>
        <span>{assu.ruches}</span>
      </TableCell>
      <TableCell className="block px-0 pb-0 pt-3 text-right sm:table-cell sm:px-6 sm:py-4">
        {facturesImpayees.length === 0 ? (
          <Button
            className="w-full bg-[#173f35] hover:bg-[#23594a] sm:w-auto"
            onClick={() => telechargerAttestation()}
            loading={loadingAttestation}
            icon={<Download className="h-4 w-4" />}
            size="sm"
          >
            Télécharger
          </Button>
        ) : (
          <div className="inline-flex w-full justify-center rounded-full bg-[#fff6d8] px-3 py-1.5 text-xs font-semibold text-[#725716] sm:w-auto">
            En attente de paiement
          </div>
        )}
      </TableCell>
    </TableRow>
  );
};

export default AttestationAssuranceRowItem;
